import { BehaviorSubject } from 'rxjs';
import { CoordinatorService } from './coordinator.service';
import { Section, TAG } from './section';

export class Stats$ {
    sectionMap = new Map<string, Section>();
    currentSection$: BehaviorSubject<Section>;

    showEmpty$ = new BehaviorSubject<boolean>(true);

    constructor(public coords: CoordinatorService) {
        // const sLs: Section[] = []
        // coords.sectionOrderLs.forEach(x =>
        //     sLs.push(new Section(coords, x)))
        // sLs.push(new Section(this.coords, "overlaps"))
        const sLs = [new Section(this.coords, 'overlaps')];
        // new Section(this.coords, "train"),
        // sLs.push(new Section(this.coords, "databins"))
        sLs.forEach((x) => this.sectionMap.set(x.tag, x));
        this.currentSection$ = new BehaviorSubject<Section>(this.sectionLs[0]);
    }

    get sectionLs() {
        const ls = Array.from(this.sectionMap.values());
        this.coords.script$?.isSummaryLs.forEach((x) =>
            ls.push(new Section(this.coords, x.title as TAG, x)),
        );
        return ls;
    }
}
